import React, { Component } from 'react';
import {
  ListItem,
} from 'material-ui';

export default class AccountListItem extends Component {
  render() {
    const account = this.props.account; // this.state.people[id];
    const selected = !!this.props.selected;
    const onTouchTap = this.props.onTouchTap || (() => {})

    return (
      <ListItem
        value={account.id}
        style={{backgroundColor: selected ? "rgba(0, 0, 0, 0.2)" : ''}}
        primaryText={account.name || "?"}
        // secondaryText={account.preview}
        onTouchTap={onTouchTap}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/AccountListItem.js